export default __webpack_public_path__ + "static/media/dollar-black.ccdf38c9.svg";